import { useEffect, useState } from 'preact/hooks';
import { getConfigurationFor as defaultGetConfigurationFort } from '@thesavingsgroup/remote-configuration/getConfigurationFor';
import type { RemoteConfiguration } from '@thesavingsgroup/remote-configuration/types/RemoteConfiguration';
import type { ESEMode } from '@thesavingsgroup/remote-configuration/types/ESEMode';
import { reporter } from '../reporter';
import { useQueryParams as defaultUseQueryParams } from './useQueryParams';

export const useConfiguration = (
  getConfigurationFor = defaultGetConfigurationFort,
  useQueryParams = defaultUseQueryParams,
) => {
  const { configurationCode, uniqueIdentifier } = useQueryParams() || {};

  const [configuration, setConfiguration] =
    useState<RemoteConfiguration | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!configurationCode) {
      setError('No configuration code provided');
      setLoading(false);
      return;
    }

    setLoading(true);

    getConfigurationFor({ reporter, mode: import.meta.env.MODE as ESEMode })(
      configurationCode,
      uniqueIdentifier,
    )
      .then(setConfiguration)
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        // delay the loading state change
        setTimeout(() => setLoading(false), 1000);
      });
  }, [configurationCode, uniqueIdentifier]);

  return { configuration, loading, error };
};
